import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/permutation-calculator',
  component: () => import('../../routes/PermutationCalculator.svelte'),
  card: {
    id: 'permutation-calculator',
    title: 'Permutation Calculator',
    description: 'Calculate the number of ordered arrangements (nPr) and combinations (nCr) from n items taken r at a time.',
    icon: 'sync_alt',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/permutation-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Permutation Calculator – nPr and nCr Calculator with Step-by-Step Breakdown',
    description: 'Free permutation calculator. Compute ordered arrangements (nPr) and combinations (nCr) with step-by-step breakdown, digit count, and ln(nPr). Perfect for combinatorics and probability calculations.',
  },
};

export default meta;